import type { CheckboxTreeItem } from '../components/CheckboxTree/types';
import type { LabelHierarchy } from '../types';

export function mapLabelHierarchyToCheckboxTreeItem(
  items: LabelHierarchy[],
  labelIdSet?: Set<number>,
): CheckboxTreeItem[] {
  if (items.length === 0) {
    return [];
  }

  return items.map((item) => {
    const mappedChildren = mapLabelHierarchyToCheckboxTreeItem(
      item.child_labels,
      labelIdSet,
    );
    let children: CheckboxTreeItem[] | undefined;

    if (item.child_labels.length > 0) {
      children = mappedChildren;
    }

    return {
      id: item.label_id.toString(),
      label: item.name,
      checked: labelIdSet?.has(item.label_id) ?? false,
      isVisible: true,
      isExpanded: false,
      children,
    };
  });
}
